<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="用户管理" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini">
								<el-form-item label="用户名称">
									<el-input v-model="searchForm.user_name" placeholder="请填写用户名称" clearable></el-input>
								</el-form-item>
								<el-form-item label="所属部门" prop="department_id">
									<el-cascader v-model="searchForm.department_id" :options="options.department_search_options"
										:props="{ checkStrictly: true, label: 'department_name', value: 'id' }" clearable></el-cascader>
								</el-form-item>
								<el-form-item label="电话">
									<el-input v-model="searchForm.user_phone" placeholder="请填写电话" clearable></el-input>
								</el-form-item>
								<el-form-item label="用户状态">
									<el-select v-model="searchForm.status" placeholder="请选择用户状态" clearable>
										<el-option label="正常" value="YES"></el-option>
										<el-option label="封禁" value="NO"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="邮箱">
									<el-input v-model="searchForm.user_email" placeholder="请填写邮箱" clearable></el-input>
								</el-form-item>
								<el-form-item label="创建日期">
									<el-date-picker clearable align="center" v-model="searchForm.create_time" type="daterange"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
										end-placeholder="结束日期"></el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
									<el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;">
								<div>
									<el-button type="primary" size="mini"
										v-if="$parent.$parent.isAuthAction('admin/users/user/createuser')"
										@click="addUserOpen">添加用户</el-button>
								</div>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" style="width: 100%" border stripe ref="table" highlight-current-row
									@sort-change="sortChange" :height="tableHeight">
									<el-table-column fixed prop="id" label="id" align="center" min-width="55">
									</el-table-column>
									<el-table-column fixed prop="user_name" label="用户名称" min-width="150">
									</el-table-column>
									<el-table-column prop="user_phone" label="电话" min-width="120">
									</el-table-column>
									<el-table-column prop="user_email" label="邮箱" min-width="150">
									</el-table-column>
									<el-table-column prop="is_leader" label="部门负责人" min-width="100">
										<template slot-scope="scope">
											<el-tag :size="size" v-if="scope.row.is_leader == 1" type="danger">是</el-tag>
											<el-tag :size="size" v-if="scope.row.is_leader == 2" type="success">否</el-tag>
										</template>
									</el-table-column>
									<el-table-column prop="status" label="用户状态" min-width="100">
										<template slot-scope="scope">
											<el-tag :size="size" v-if="scope.row.status == 'YES'" type="success">正常</el-tag>
											<el-tag :size="size" v-if="scope.row.status == 'NO'" type="danger">封禁</el-tag>
										</template>
									</el-table-column>
									<el-table-column prop="position_name" label="职称名称" min-width="120">
									</el-table-column>
									<el-table-column prop="department_name" label="所属部门" min-width="100">
									</el-table-column>
									<el-table-column v-if="isSupper()" prop="department_role_name" label="所属角色" min-width="100">
									</el-table-column>
									<el-table-column prop="groups" label="所属组" min-width="120">
										<template slot-scope="scope">
											<el-tag v-for="(ii, index) in scope.row.groups" :key="index + 'tag'" :size="size"
												type="success">{{
													ii }}</el-tag>
										</template>
									</el-table-column>
									<el-table-column prop="company_name" label="所属公司" min-width="150">
									</el-table-column>
									<el-table-column prop="create_time" label="创建时间" width="150" sortable="custom">
									</el-table-column>
									<el-table-column prop="update_time" label="修改时间" width="150" sortable="custom">
									</el-table-column>
									<el-table-column fixed="right" label="操作" min-width="280">
										<template slot-scope="scope">
											<el-button @click="handleTableUserOpen(scope.row)" type="text" size="small"
												v-if="$parent.$parent.isAuthAction('admin/users/user/userrelationadgroups')">关联用户组</el-button>
											<el-button @click="handleTableEditOpen(scope.row)" type="text" size="small"
												v-if="$parent.$parent.isAuthAction('admin/users/user/edituser')">编辑</el-button>
											<el-button @click="handleTableDelete(scope.row)" type="text" size="small" class="c-danger"
												v-if="scope.row.is_supper != 'ADMIN' && $parent.$parent.isAuthAction('admin/users/user/deleteuser')">删除</el-button>
											<el-button
												v-if="scope.row.is_supper == 'USER' && $parent.$parent.isAuthAction('admin/users/login/editpassword')"
												@click="handleTableUpdatePassword(scope.row)" type="text" size="small"
												class="c-danger">重置密码</el-button>
											<el-button
												v-if="scope.row.is_supper != 'ADMIN' && isSupper && $parent.$parent.isAuthAction('admin/users/user/simulatedlogin')"
												@click="handleTableLogin(scope.row)" type="text" size="small" class="c-danger">模拟登录</el-button>
										</template>
									</el-table-column>

								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--添加用户-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" :wrapperClosable="false"
			:close-on-press-escape="false" direction="rtl" size="40%">
			<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>添加用户</span>
						<i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="用户名称" prop="user_name">
						<el-input v-model="addForm.user_name" placeholder="请填写用户名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="手机号码" prop="user_phone">
						<el-input v-model="addForm.user_phone" placeholder="请填写手机号码" clearable></el-input>
					</el-form-item>
					<el-form-item label="登录邮箱" prop="user_email">
						<el-input v-model="addForm.user_email" placeholder="请填写登录邮箱" clearable></el-input>
					</el-form-item>
					<el-form-item label="职位职称" prop="position_id">
						<el-select v-model="addForm.position_id" ref="template" placeholder="请选择" @focus="getPositionOption"
							@visible-change="(v) => visibleChange(v, 'template')" :style="{ width: '100%' }" filterable clearable>
							<el-option v-for="item in options.position_options" :key="item.value" :label="item.label"
								:value="item.value">
								<span style="float: left" class="span-style">{{ item.label }}</span>
								<span style="float: right" class="span-style-delete" v-if="item.isDel" @click.stop="deleteItem(item)"><i
										class="el-icon-delete" /></span>
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="所属公司" prop="company_id">
				  <el-select v-model="addForm.company_id" placeholder="请选择所属公司" @change="getDepartmentOption">
				    <el-option
				      v-for="item in options.company_id_options"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value"
				    ></el-option>
				  </el-select>
				</el-form-item> -->
					<el-form-item label="所属部门" prop="department_id">
						<el-cascader v-model="addForm.department_id" :options="options.department_options"
							:props="{ checkStrictly: true, label: 'department_name', value: 'id' }" clearable></el-cascader>
					</el-form-item>

					<el-form-item label="部门角色" prop="department_role_id">
						<el-select v-model="addForm.department_role_id" placeholder="请选择">
							<el-option v-for="item in options.department_role_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-row>
						<el-col :span="18">
							<el-form-item label="登录密码" prop="password">
								<el-input v-model="addForm.password" placeholder="请填写用户登录密码" clearable></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-button type="primary" :size="size" @click="makePassword('addForm')"
								style="margin-left:5px;">随机密码</el-button>
						</el-col>
					</el-row>
					<el-form-item label="再次填写密码" prop="repassword">
						<el-input v-model="addForm.repassword" placeholder="请再次填写密码" clearable></el-input>
					</el-form-item>
					<el-form-item label="部门负责人" prop="is_leader">
						<el-radio-group v-model="addForm.is_leader">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="2">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="用户状态" prop="status">
						<el-radio-group v-model="addForm.status">
							<el-radio label="YES">正常</el-radio>
							<el-radio label="NO">封禁</el-radio>
						</el-radio-group>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="addUser" :size='size'>提交</el-button>
					<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!--编辑用户-->
		<el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" :wrapperClosable="false"
			:close-on-press-escape="false" direction="rtl" size="40%">
			<el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>编辑用户</span>
						<i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="用户名称" prop="user_name">
						<el-input v-model="editForm.user_name" placeholder="请填写用户名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="手机号码" prop="user_phone">
						<el-input v-model="editForm.user_phone" placeholder="请填写手机号码" clearable></el-input>
					</el-form-item>
					<el-form-item label="登录邮箱" prop="user_email">
						<el-input v-model="editForm.user_email" placeholder="请填写登录邮箱" clearable></el-input>
					</el-form-item>
					<el-form-item label="职位职称" prop="position_id">
						<el-select v-model="editForm.position_id" ref="template" placeholder="请选择" @focus="getPositionOption"
							@visible-change="(v) => visibleChange(v, 'template')" :style="{ width: '100%' }" filterable clearable>
							<el-option v-for="item in options.position_options" :key="item.value" :label="item.label"
								:value="item.value">
								<span style="float: left" class="span-style">{{ item.label }}</span>
								<span v-if="item.isDel" style="float: right" class="span-style-delete" @click.stop="deleteItem(item)"><i
										class="el-icon-delete" /></span>
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="所属公司" prop="company_id">
				  <el-select v-model="editForm.company_id" placeholder="请选择所属公司" @change="getDepartmentOption">
				    <el-option
				      v-for="item in options.company_id_options"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value"
				    ></el-option>
				  </el-select>
				</el-form-item> -->
					<el-form-item label="所属部门" prop="department_id">
						<el-cascader v-model="editForm.department_id" :options="options.department_options"
							:props="{ checkStrictly: true, label: 'department_name', value: 'id' }" clearable></el-cascader>
					</el-form-item>

					<el-form-item label="部门角色" prop="department_role_id">
						<el-select v-model="editForm.department_role_id" placeholder="请选择">
							<el-option v-for="item in options.department_role_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="部门负责人" prop="is_leader">
						<el-radio-group v-model="editForm.is_leader">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="2">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="用户状态" prop="status">
						<el-radio-group v-model="editForm.status">
							<el-radio label="YES">正常</el-radio>
							<el-radio label="NO">封禁</el-radio>
						</el-radio-group>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="editUser" :size='size'>提交</el-button>
					<el-button :size='size' @click="editFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!--添加职位职称-->
		<el-dialog title="添加职位职称" v-loading="loading" :close-on-click-modal="false" :visible.sync="addPositionVisiable"
			width="40%">
			<el-form :model="addPositionForm" ref="addPositionForm" :size="size" :rules="rules.addPositionForm"
				label-width="110px">
				<el-form-item label="职位职称" prop="position_name">
					<el-input v-model="addPositionForm.position_name" placeholder="请填写职位职称" clearable></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addPosition" :size='size'>提交</el-button>
				<el-button :size='size' @click="addPositionVisiable = false">取消</el-button>
			</span>
		</el-dialog>
		<!--关联用户组权限-->
		<el-dialog title="关联用户组" v-loading="loading" :close-on-click-modal="false" :visible.sync="groupFormVisiable"
			width="40%">
			<el-form :model="groupForm" ref="groupForm" :size="size" :rules="rules.groupForm" label-width="110px"
				v-loading="loading">
				<div>
					<el-form-item label="关联用户组" prop="group_ids">
						<el-select v-model="groupForm.group_ids" multiple clearable placeholder="请选择用户组名称" style="width: 100%;">
							<el-option v-for="item in options.group_options" :key="item.id" :label="item.group_name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="handleTableGroup" :size='size'>提交</el-button>
				<el-button :size='size' @click="groupFormVisiable = false">取消</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		// 密码验证规则
		var validateAddPass = function (rule, value, callback) {
			var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,16}$/
			if (!regex.test(value)) {
				callback(
					new Error('密码长度 8 - 16 位，至少包含大写字母，小写字母和数字')
				)
			} else {
				this.$refs.addForm.validateField('repassword')
				callback()
			}
		}.bind(this)
		var validateAddRePass = function (rule, value, callback) {
			if (value !== this.addForm.password) {
				callback(new Error('两次输入密码不一致!'))
			} else {
				callback()
			}
		}.bind(this)
		// 密码验证规则
		var validateEditPass = function (rule, value, callback) {
			var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,16}$/
			if (!value) {
				callback()
			} else if (!regex.test(value)) {
				callback(
					new Error('密码长度 8 - 16 位，至少包含大写字母，小写字母和数字')
				)
			} else {
				this.$refs.editForm.validateField('repassword')
				callback()
			}
		}.bind(this)
		var validateEditRePass = function (rule, value, callback) {
			if (this.editForm.repassword !== this.editForm.password) {
				callback(new Error('两次输入密码不一致!'))
			} else {
				callback()
			}
		}.bind(this)
		return {
			options: [
				{
					value: 1,
					label: "黄金糕",
				},
				{
					value: 2,
					label: "双皮奶",
				},
				{
					value: 3,
					label: "蚵仔煎",
				},
				{
					value: 4,
					label: "龙须面",
				},
				{
					value: 5,
					label: "北京烤鸭",
				},
			],
			formData: {
				value: "",
			},
			loading: false,
			addFormVisiable: false,
			editFormVisiable: false,
			addPositionVisiable: false,
			groupFormVisiable: false,
			activeName: 'first',
			size: 'mini',
			options: {
				department_search_options: [],
				//职位职称
				position_options: [],
				//部门
				department_options: [],
				//部门内角色
				department_role_options: [],
				company_id_options: [],
				group_options: []
			},
			searchForm: {
				user_name: '',
				user_phone: '',
				status: '',
				user_email: '',
				department_id: [],
				create_time: []
			},
			resetSearch: {
				user_name: '',
				user_phone: '',
				status: '',
				user_email: '',
				department_id: [],
				create_time: []
			},
			addForm: {
				user_name: '',
				user_phone: '',
				user_email: '',
				password: '',
				repassword: '',
				is_leader: 2,
				status: 'YES',
				position_id: '',
				department_id: [],
				//   company_id:'',
				department_role_id: ''
			},
			editForm: {
				id: '',
				user_name: '',
				user_phone: '',
				user_email: '',
				is_leader: 2,
				status: 'YES',
				position_id: '',
				department_id: [],
				// company_id:'',
				department_role_id: ''
			},
			addPositionForm: {
				position_name: ''
			},
			groupForm: {
				group_ids: []
			},
			rules: {
				addForm: {
					user_name: [
						{ required: true, message: '请填写用户名称', trigger: ['change', 'blur'] },
						{ max: 25, message: '名称长度不能超过 25 个汉字或字符', trigger: ['change', 'blur'] }
					],
					user_phone: [
						{ required: true, message: "请输入手机号", trigger: "blur" },
						{
							pattern: /^1[3456789]\d{9}$/,
							message: "手机号格式不正确",
							trigger: ["blur", "change"]
						}
					],
					user_email: [
						{ required: true, message: "请输入邮箱", trigger: "blur" },
						{ type: "email", message: "邮箱格式不正确", trigger: ["blur", "change"] }
					],
					position_id: [
						{ required: true, message: '请选择职位职称', trigger: ['change'] }
					],
					department_id: [
						{ required: true, message: '请选择所属部门', trigger: ['change'] }
					],
					department_role_id: [
						{ required: true, message: '请选择部门角色', trigger: ['change'] }
					],
					//   company_id: [
					//     {required: true, message: '请选择所属公司', trigger: ['change']}
					//   ],
					password: [
						{ required: true, message: '请填写用户登录密码，或生成随机密码', trigger: ['blur'] },
						{ validator: validateAddPass, trigger: ['blur'] }
					],
					repassword: [
						{ required: true, message: '请再次填写用户登录密码，或生成随机密码', trigger: ['blur'] },
						{ validator: validateAddRePass, trigger: ['blur'] }
					]
				},
				editForm: {
					user_name: [
						{ required: true, message: '请填写用户名称', trigger: ['change', 'blur'] },
						{ max: 25, message: '名称长度不能超过 25 个汉字或字符', trigger: ['change', 'blur'] }
					],
					user_phone: [
						{ required: true, message: "请输入手机号", trigger: "blur" },
						{
							pattern: /^1[3456789]\d{9}$/,
							message: "手机号格式不正确",
							trigger: ["blur", "change"]
						}
					],
					user_email: [
						{ required: true, message: "请输入邮箱", trigger: "blur" },
						{ type: "email", message: "邮箱格式不正确", trigger: ["blur", "change"] }
					],
					position_id: [
						{ required: true, message: '请选择职位职称', trigger: ['change'] }
					],
					department_id: [
						{ required: true, message: '请选择所属部门', trigger: ['change'] }
					],
					department_role_id: [
						{ required: true, message: '请选择部门角色', trigger: ['change'] }
					],
					company_id: [
						{ required: true, message: '请选择所属公司', trigger: ['change'] }
					]
				},
				addPositionForm: {
					position_name: [
						{ required: true, message: '请填写职位职称', trigger: ['change', 'blur'] },
						{ max: 25, message: '名称长度不能超过 25 个汉字或字符', trigger: ['change', 'blur'] }
					]
				},
				groupForm: {
					group_ids: [
						{ required: true, message: '请选择用户组', trigger: ['blur'] }
					]
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			}
		}
	},
	computed: {
		tableHeight: function () {
			return window.innerHeight - 320;
		},
		apiMainHeight: function () {
			var height = window.innerHeight - 180;
			return { height: height + 'px', border: '1px solid #DCDFE6', 'margin-bottom': '10px' }
		},
	},
	mounted: function () {
		this.getDepartmentOptionSearch()
		this.handleSearch(this.searchForm)
	},
	methods: {
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		isSupper () {
			return this.info.views.isSupper
		},
		//列表
		handleSearch (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : this.tableData.page;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/users/user/getlistuser', param).then(res => {
				if (res.code == 0) {
					this.$set(this, 'tableData', res.data)
					this.$nextTick(() => {
						// 调用 doLayout
						this.$refs.table.doLayout()
					})
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm, 0)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		//添加弹窗
		addUserOpen () {
			this.addForm = {
				user_name: '',
				user_phone: '',
				user_email: '',
				password: '',
				repassword: '',
				is_leader: 2,
				status: 'YES',
				position_id: '',
				department_id: '',
				department_role_id: ''
			}
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			this.getDepartmentRolesOption()
			this.getPositionOption()
			this.getDepartmentOption()
			this.addFormVisiable = true
		},
		//添加
		addUser () {
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/users/user/createuser', this.addForm).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '用户添加成功！',
								type: 'success'
							});
							this.addFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})

				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		// 生成 10 位随机密码
		makePassword: function (form) {
			var password = Math.random().toString(36).substr(2, 10)
			var arr = password.split('')
			var result = []
			var nochange = true
			arr.forEach(function (item, index) {
				if (!(item >= 0 && item <= 9)) {
					if (nochange) {
						item = item.toLocaleUpperCase()
						nochange = false
					} else {
						nochange = true
					}
				}
				result.push(item)
			})
			result = result.join('')
			this[form].password = result
			this[form].repassword = result
			this.$forceUpdate()
		},
		//编辑弹窗
		handleTableEditOpen (row) {
			this.$api.get('/admin/users/user/getuserinfo', { id: row.id }).then(res => {
				if (res.code === 0) {
					this.editForm = res.data
					this.getDepartmentOption(res.data.company_id)
					this.getDepartmentRolesOption(row.id)
					this.getPositionOption(row.id)
					//   this.getCompanyOption()
					this.editFormVisiable = true;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//编辑
		editUser () {
			this.$refs['editForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.put('/admin/users/user/edituser', this.editForm).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '用户信息修改成功！',
								type: 'success'
							});
							this.editFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		//删除
		handleTableDelete (row) {
			this.$confirm('此操作将永久删除该部门, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/users/user/deleteuser', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							} else if (item.children) {
								item.children.forEach(function (value, key) {
									if (value.id == row.id) {
										this.$delete(item.children, key);
									}
								}.bind(this));
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该用户已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		//重置密码
		handleTableUpdatePassword (row) {
			this.$confirm('确定重置密码吗？', '重置密码', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.$api.post('/admin/users/login/editpassword', { id: row.id }).then(res => {
					if (res.code === 0) {
						const textarea = document.createElement('textarea');
						textarea.value = res.msg;
						document.body.appendChild(textarea);
						textarea.select();
						document.execCommand('copy');
						document.body.removeChild(textarea);
						this.$message({
							showClose: true,
							message: '新密码已复制到剪贴板！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
				})
			}.bind(this))
		},
		getDepartmentOptionSearch () {
			this.$api.get('/admin/users/department/getdepartmentsearch', { type: 'two' }).then(res => {
				if (res.code === 0) {
					this.options.department_search_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//获取部门下拉
		getDepartmentOption (id) {
			this.$api.get('/admin/users/department/getdepartmentsearch', { type: 'two' }).then(res => {
				if (res.code === 0) {
					this.options.department_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取部门角色下拉
		getDepartmentRolesOption (id) {
			this.$api.get('/admin/users/departmentrole/getdepartmentrolesearch', { id: id ? id : '' }).then(res => {
				if (res.code === 0) {
					this.options.department_role_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取所属公司
		getCompanyOption () {
			this.$api.get('/admin/customers/customer/getCompanySelect', {}).then(res => {
				if (res.code === 0) {
					this.options.company_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取职位职称下拉
		getPositionOption (id) {
			this.$api.get('/admin/users/position/getpositionsearch', { id: id ? id : '' }).then(res => {
				if (res.code === 0) {
					this.options.position_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 职位职称下拉时显示底下的新增按钮
		visibleChange (visible, refName) {
			if (visible) {
				const ref = this.$refs[refName];
				let product = ref.$refs.popper;
				if (product.$el) product = product.$el;
				if (
					!Array.from(product.children).some(
						(v) => v.className === "el-template-menu__list"
					)
				) {
					const el = document.createElement("ul");
					el.className = "el-template-menu__list";
					el.style =
						"border-top:1px solid rgb(219 225 241); padding:0; color:rgb(64 158 255);font-size: 13px";
					el.innerHTML = `<li class="el-cascader-node text-center" style="height:37px;line-height: 50px;">
				<span class="el-cascader-node__label" style="padding:0;"><i class="font-blue el-icon-plus"></i> 新增职位职称</span>
				</li>`;
					product.appendChild(el);
					// 新增按钮点击事件
					el.onclick = () => {
						this.addItem();
					};
				}
			}
		},
		//删除职位职称
		deleteItem (item) {
			this.$confirm('此操作将永久删除该部门, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/users/position/deleteposition', { id: item.value }).then(res => {
					if (res.code === 0) {
						this.addForm.position_id = ''
						this.editForm.position_id = ''
						this.options.position_options = this.options.position_options.filter((e) => e.value != item.value);
						this.$message({
							showClose: true,
							message: '该职位职称已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		// 添加职位职称弹窗
		addItem () {
			this.addPositionVisiable = true
		},
		addPosition () {
			this.$refs['addPositionForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/users/position/createposition', this.addPositionForm).then(res => {
						if (res.code === 0) {
							this.$message({
								showClose: true,
								message: '职位职称添加成功！',
								type: 'success'
							});
							this.addPositionVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})

				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		//关联用户组弹窗
		handleTableUserOpen (row) {
			this.loading = true;
			this.groupFormVisiable = true;
			this.groupForm.group_ids = []
			this.$api.get('/admin/fyauth/fyauth/groupDownList').then(res => {
				if (res.code === 0) {
					this.options.group_options = res.data;
					this.$api.get('/admin/users/user/getuserrelationadgroups', { user_id: row.id }).then(res => {
						if (res.code === 0) {
							this.groupForm.group_ids = res.data
							this.groupForm.user_id = row.id
							this.loading = false
						} else {
							this.$message.error(res.msg);
						}
					})
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		handleTableGroup () {
			this.loading = true;
			this.$api.post('/admin/users/user/userrelationadgroups', this.groupForm).then(res => {
				if (res.code === 0) {
					this.$message({
						showClose: true,
						message: '用户组关联成功！',
						type: 'success'
					});
					this.groupFormVisiable = false;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//模拟登录
		handleTableLogin (row) {
			this.$api.post('/admin/users/user/simulatedlogin', { id: row.id }).then(res => {
				if (res.code === 0) {
					localStorage.setItem('fy-token', res.msg)
					this.$message({
						showClose: true,
						message: '成功登录！',
						type: 'success'
					});
					setTimeout(() => {
						window.location.replace("/")
						// this.$router.push('/');
					}, 1000);
				} else {
					this.$message.error(res.msg);
				}
			})
		}
	}
}
</script>
<style lang="scss" scoped>
.select {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;

	.form {
		padding-top: 100px;
		width: 500px;
	}
}
</style>